// @flow
import React, { Fragment, PureComponent } from "react";
import { noop } from "lodash";

import type { NullaryFn } from "@tvg/types/Functional";
import buildColor from "@fdr/static-ui/ColorPalette";
import Icon from "@fdr/static-ui/Icons";
import { notification, tick } from "@fdr/static-ui/Icons/icons";
import { createPortal } from "react-dom";

import { NotificationIcon, NotificationMessage } from "./styled-components";

type Props = {
  isOn: boolean,
  raceNumber?: string,
  hasTopMargin: boolean,
  showTopBorder: boolean,
  showBottomBorder: boolean,
  onToggleClick: NullaryFn<mixed>,
  notificationType: string,
  notificationMessage: string,
  isBettingModalOpen: boolean
};

export default class RaceAlerts extends PureComponent<Props> {
  static defaultProps = {
    isOn: false,
    raceNumber: "",
    hasTopMargin: false,
    showTopBorder: true,
    showBottomBorder: true,
    onToggleClick: noop,
    showMessage: false,
    notificationType: "",
    notificationMessage: "",
    isBettingModalOpen: false
  };

  render() {
    return (
      <Fragment>
        <NotificationIcon
          on={this.props.isOn}
          onClick={this.props.onToggleClick}
        >
          <Icon
            icon={notification}
            size={16}
            color={buildColor("blue", "500")}
          />
        </NotificationIcon>
        {this.props.notificationMessage &&
          createPortal(
            <NotificationMessage
              isBettingModalOpen={this.props.isBettingModalOpen}
              className={this.props.notificationType}
            >
              <Icon icon={tick} size={16} />
              {this.props.notificationMessage}
            </NotificationMessage>,
            // $FlowFixMe
            document.body
          )}
      </Fragment>
    );
  }
}
